import { render } from "./AppPreloader.vue?vue&type=template&id=22bc5215"
import script from "./AppPreloader.vue?vue&type=script&lang=js"
export * from "./AppPreloader.vue?vue&type=script&lang=js"

import "./AppPreloader.vue?vue&type=style&index=0&id=22bc5215&lang=css"
script.render = render

export default script